// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"7a3387fb","709":"400fb9af"}[chunkId] + ".chunk.css";
};